import { Component, OnInit, Input } from '@angular/core';


@Component({
  selector: 'app-solde',
  templateUrl: './solde.component.html',
  styleUrls: ['./solde.component.scss']
})
export class SoldeComponent implements OnInit {

  @Input() appareilName: string;
  solde: string = "";

  constructor() {
    this.appareilName = "izly";
  }

  ngOnInit(): void {
    if (this.appareilName == "papercut") {
      this.solde = "Solde : 2€";
    }
    else {
      this.solde = "Solde : 12€";
    }
  }

}
